{
  "assignment": {
    "defaultTitle": "Envie sua Atividade",
    "maxFilesError_one": "Máximo de {{count}} arquivo permitido",
    "maxFilesError_zero": "Máximo de {{count}} arquivos permitidos",
    "maxFilesError_other": "Máximo de {{count}} arquivos permitidos",
    "fileTooLarge": "{{name}} é muito grande. Máximo: {{size}}MB",
    "fileUploaded": "{{name}} enviado com sucesso!",
    "fileUploadError": "Erro ao enviar {{name}}",
    "addAtLeastOne": "Adicione pelo menos um arquivo",
    "waitAllUploads": "Aguarde todos os arquivos serem enviados",
    "submitted": "Atividade enviada com sucesso!",
    "submitError": "Erro ao enviar atividade",
    "dropHere": "Solte os arquivos aqui...",
    "clickOrDrag": "Clique ou arraste arquivos aqui",
    "limits_one": "Máximo {{count}} arquivo, {{size}}MB cada",
    "limits_zero": "Máximo {{count}} arquivos, {{size}}MB cada",
    "limits_other": "Máximo {{count}} arquivos, {{size}}MB cada",
    "acceptedTypes": "Tipos aceitos: {{types}}",
    "filesCount": "Arquivos ({{total}})",
    "status": {
      "completed": "Enviado",
      "error": "Erro",
      "uploading": "Enviando..."
    },
    "commentsLabel": "Comentários (opcional)",
    "commentsPlaceholder": "Adicione comentários sobre sua atividade...",
    "hint": {
      "empty": "Adicione arquivos para continuar",
      "waiting": "Aguarde o upload concluir",
      "ready": "Pronto para enviar!",
      "errors": "Alguns arquivos falharam no upload"
    },
    "submitting": "Enviando...",
    "submit": "Enviar Atividade"
  },
  "download": {
    "defaultTitle": "Materiais para Download",
    "fileType": {
      "code": "Código",
      "file": "Arquivo"
    },
    "downloaded": "{{name}} baixado com sucesso!",
    "error": "Erro ao baixar arquivo",
    "startingAll": "Iniciando download de todos os arquivos...",
    "status": {
      "downloading": "Baixando...",
      "completed": "Baixado!",
      "error": "Erro",
      "idle": "Baixar"
    },
    "downloadAll": "Baixar Todos",
    "tips": {
      "title": "💡 Dicas de Download",
      "programs": "• Alguns arquivos podem precisar de programas específicos para abrir",
      "organize": "• Mantenha seus materiais organizados em uma pasta do curso",
      "zip": "• Arquivos ZIP contêm múltiplos arquivos compactados",
      "code": "• Arquivos de código podem ser abertos em editores como VS Code"
    }
  },
  "pdf": {
    "loaded_one": "PDF carregado: {{count}} página",
    "loaded_zero": "PDF carregado: {{count}} páginas",
    "loaded_other": "PDF carregado: {{count}} páginas",
    "loadErrorDescription": "Erro ao carregar PDF. Verifique se o arquivo é válido.",
    "loadError": "Erro ao carregar PDF",
    "downloadStarted": "Download iniciado!",
    "downloadPdf": "Baixar PDF",
    "defaultTitle": "Documento PDF",
    "pages_one": "{{count}} página",
    "pages_zero": "{{count}} páginas",
    "pages_other": "{{count}} páginas",
    "download": "Baixar",
    "exitFullscreen": "Sair",
    "fullscreen": "Tela cheia",
    "pageOf": "{{page}} de {{total}}",
    "loading": "Carregando PDF...",
    "navigationHint": "Use as setas ← → para navegar entre as páginas"
  },
  "richText": {
    "readingCompleted": "📖 Leitura concluída!",
    "readingCompletedDescription": "Você leu todo o conteúdo desta aula.",
    "copied": "Conteúdo copiado!",
    "defaultTitle": "Conteúdo da Aula",
    "preparingPrint": "Preparando para impressão...",
    "readTime": {
      "lessThanOne": "Menos de 1 min",
      "one": "1 min",
      "many": "{{minutes}} mins"
    },
    "percentRead": "{{percent}}% lido",
    "hide": "Ocultar",
    "show": "Mostrar",
    "copy": "Copiar",
    "print": "Imprimir",
    "progress": "Progresso:",
    "endOfContent": "Fim do conteúdo"
  },
  "video": {
    "embedLoadError": "Não foi possível carregar o vídeo. Verifique o link da aula.",
    "downloadNotAllowed": "Download não permitido",
    "actionBlocked": "Ação bloqueada por segurança",
    "lessonCompleted": "Aula concluída!",
    "lessonCompletedDescription": "Parabéns! Você assistiu a aula completa.",
    "invalidId": "ID do vídeo inválido",
    "expectedFormat": "Formato esperado: 24 caracteres hexadecimais"
  },
  "media": {
    "invalidImageType": "Tipo de arquivo inválido. Use JPG, PNG, GIF ou WebP.",
    "invalidVideoType": "Tipo de arquivo inválido. Use MP4, WebM, MOV ou AVI."
  }
}
